// extracted by mini-css-extract-plugin
export default {"container":"NoResponseComponent__container___iRXrn","text":"NoResponseComponent__text___PuyHL"};